import src from "IMAGE";
export default { src, width: 2943, height: 550, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ANLS0i3CwsI8wcHBPcrKyjPJyck0vb29QL6+vj/FxcU4VsAUPbgejqMAAAAASUVORK5CYII="};
